// billing-service 在网关上的两个入口。
//
// billing-service-public/page 是按白名单放行的页面入口，只开放 Home 页面和被 Home 用 iframe
// 嵌入的页面会调的接口（清单见 billing-agent 仓 kb/fe/billing-api-home-iframe.md）；dashboard
// 的内部接口在这个入口下是 404（2026-10-12 dev 实测 /user/billingInternalPermission）。
// 所以只有嵌在 iframe 里时走它；独立打开的页面（dashboard、Go WebApp、直接访问的 microapp）
// 仍走原入口，行为不变。
export const DEFAULT_BILLING_BASE = '/route-billing/billing-service'
export const PAGE_BILLING_BASE = '/route-billing/billing-service-public/page'

// 判定条件与 router/index.js 区分 iframe 模式的一致
export function billingApiBase (win = window) {
  return win.self !== win.top ? PAGE_BILLING_BASE : DEFAULT_BILLING_BASE
}
